<template>
  <SvgIcon v-if="type" :type="type" :style="styles" v-bind="$attrs" />
</template>

<script setup lang="ts" name="BaseIconSvg">
  import { toRefs, computed, withDefaults } from 'vue';
  import { createFromIconfontCN } from '@shared/assets/icons-vue';
  import { isNumber, isDef, px2rem } from '@shared/utils';
  import iconFontJSPath from '@shared/assets/font/iconfont.js?url';

  type TProps = {
    // 图标类型
    type: string;
    // 图标颜色
    color?: string;
    // 图标尺寸
    size?: number | string;
    // 阿里图库字体图标路径
    scriptUrl?: string | string[];
  };

  const props = withDefaults(defineProps<TProps>(), { type: '', prefix: '', scriptUrl: '', size: 14, color: 'unset' });
  const { type } = toRefs(props);

  let scriptUrls = [iconFontJSPath];

  let SvgIcon = createFromIconfontCN({ scriptUrl: scriptUrls });

  // 如果外部传进来字体图标路径，则覆盖默认的
  if (props.scriptUrl) {
    scriptUrls = [...new Set(scriptUrls.concat(props.scriptUrl))];
    SvgIcon = createFromIconfontCN({ scriptUrl: scriptUrls });
  }

  // 外部传进来的style样式
  const styles = computed(() => {
    const { color, size } = props;
    return `color:${color};font-size: ${addUnit(size)};`;
  });

  // 给字体添加单位
  const addUnit = (value: number | string) => {
    if (isDef(value)) {
      // console.log(isNumber(value) ? `${value}px` : String(value));
      return isNumber(value) ? `${px2rem(value)}` : String(value);
    }
  };
</script>
